import miyagi from '../elements/miyagi.js';
miyagi.register();
